import { Component } from '@angular/core';
import { OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertsService } from '../../../services/alerts.service';
import { BatchService } from '../../services/batch.service';
import { UserService } from '../../../services/user.service';

/**
 * Component for managing workflow batches.
 */
@Component({
	selector: 'workflow-batch-management',
	templateUrl: './batch-management.component.html',
	styleUrl: './batch-management.component.css'
})
export class BatchManagementComponent implements OnInit {
	@Input() batchGroup: any;

	LOCALIZATION: any;
	
	inprogress: boolean = false;

	constructor(
		private modalService: NgbActiveModal,
		private alertsService: AlertsService,
		private batchService: BatchService,
		private userService: UserService
	) { }

	ngOnInit(): void {
		this.LOCALIZATION = this.userService.LOCALIZATION;
	}
	
	/**
	 * Aborts the batch processing.
	 */
	abortBatches(): void {
		this.inprogress = true;
		
		let payload = {
			ids: this.batchGroup.batchids,
			comment: this.batchGroup.comment
		};
		
		this.batchService.massAbortBatches(payload).then(
			(response: any) => {
			    this.alertsService.success({
			        message: this.LOCALIZATION.batchAbortSuccess,
			        delay: 5000
			    });
			    this.close();
			},
			(err: any) => {
				console.error("Failed to abort batch processing", err);
			    this.alertsService.error({
			        message: this.LOCALIZATION.batchAbortError
			    });
			    this.inprogress = false;
			}
		);		
	}
	
	/**
	 * Deletes the batches.
	 */
	deleteBatches(): void {
		this.inprogress = true;
		
		let payload = {
			ids: this.batchGroup.batchids
		};
		
		this.batchService.massDeleteBatches(payload).then(
			(response: any) => {
			    this.alertsService.success({
			        message: this.LOCALIZATION.batchDeleteSuccess,
			        delay: 5000
			    });
			    this.close();
			},
			(err: any) => {
				console.error("Failed to delete batches", err);
			    this.alertsService.error({
			        message: this.LOCALIZATION.batchDeleteError
			    });
			    this.inprogress = false;
			}
		);		
	}	
		
	/**
	 * Closes the modal.
	 */
	close(): void {
		this.modalService.dismiss();
	}
}
